module.exports = __webpack_public_path__ + "static/media/trash-restore.fdbda79f.svg";